import { useId, type ReactNode } from 'react'

/**
 * Ein Abschnitt mit eigener Fläche.
 *
 * Mit Titel wird daraus ein benannter Bereich (`aria-labelledby`) — eine
 * Sprachausgabe kann die Seite dann nach Abschnitten durchgehen, statt einen
 * langen Fluss vorzulesen.
 */
export function Card({
  titel,
  aktion,
  ton = 'default',
  variant,
  children,
}: {
  titel?: ReactNode | undefined
  aktion?: ReactNode | undefined
  ton?: 'low' | 'default' | 'high' | undefined
  variant?: 'filled' | 'elevated' | 'outlined' | undefined
  children: ReactNode
}) {
  const id = useId()
  const varianteKlasse = variant ? ` karte--${variant}` : ` karte--${ton}`
  return (
    <section className={`karte${varianteKlasse}`} {...(titel ? { 'aria-labelledby': id } : {})}>
      {titel ? (
        <div className="karte__kopf">
          <h2 className="karte__titel" id={id}>
            {titel}
          </h2>
          {aktion}
        </div>
      ) : null}
      {children}
    </section>
  )
}
